module.exports = __webpack_public_path__ + "img/personal.7489e9fc.png";